export default __webpack_public_path__ + "static/media/con_trim01.18acd4f3.jpg";